import { useQuery } from '@tanstack/react-query';
import { useGoverningEventsClient } from '@/lib/api';

export interface DeviationSignal {
  id: string;
  phase: string | null;
  missing_items: string[];
  checked_items: string[];
  run_at: string | null;
  received_at: string;
  severity: 'low' | 'medium' | 'high';
  is_acknowledged: boolean;
}

export function useDeviationSignals(projectId: string) {
  const client = useGoverningEventsClient();
  return useQuery({
    queryKey: ['deviation-signals', projectId],
    queryFn: async (): Promise<DeviationSignal[]> => {
      const res = await client.get<{ signals: DeviationSignal[] }>(
        `/api/projects/${projectId}/deviation-signals`
      );
      return res.data.signals;
    },
    enabled: !!projectId,
  });
}
